import { getEnv, getBim360Hostname } from '@adsk/acs-sc-web-platform-api';
import { BIM360_HOSTNAMES } from '@adsk/acs-sc-web-platform-api/es/helpers/envConsts';
import { EntitlementsProject } from '@adsk/alloy-provider';
import { isAcsUnified } from './projectsHelper';

const getBimProjectUrl = (projectId: string, accountId: string) => {
  try {
    return `https://insight.${getBim360Hostname()}/accounts/${accountId}/projects/${projectId}/home`;
  } catch (err) {
    //TODO notify bugsnag that we cannot load host
    console.error(err);
    const env = getEnv();
    return `https://admin.${BIM360_HOSTNAMES[env]}/admin/${accountId}`;
  }
};

const urlBuilder = (path: string): string => {
  const urlObject = new URL(window.location.origin);
  urlObject.pathname = path;
  return urlObject.toString();
};

export const getInsightUrl = (accountId: string) => {
  return `/insight/accounts/${accountId}/risk`;
};

export const getAccountAdminUrl = (accountId: string, isTemplate = false) => {
  const projectType = isTemplate ? 'templates' : 'projects';

  const path = `/account-admin/${projectType}/accounts/${accountId}`;
  const url = urlBuilder(path);
  return url;
};

export const getProjectTemplateAdminUrl = (projectId: string) => {
  return urlBuilder(
    `/project-admin/template-settings/projects/${projectId}/permissions`
  );
};

export const getProjectUrl = (project: EntitlementsProject) => {
  let projectUrl: string;
  const isACC = isAcsUnified(project);
  if (project.defaultUrl) {
    projectUrl = project.defaultUrl;
  } else {
    projectUrl = isACC
      ? urlBuilder(`/docs/docs/projects/${project.id}`)
      : getBimProjectUrl(project.id, project.accountId);
  }
  return projectUrl;
};
